import { default as WJElement } from '../wje-element/element.js';
import CardContent from './card-content.element.js';

// export * from "./card-content.element.js";
export default CardContent;

WJElement.define('wje-card-content', CardContent);
